<div style="position: relative; width: 100%;
padding:20px; box-sizing: border-box; background-color: var(--mat-sys-surface-container-low); border-radius:8px;
box-shadow: var(--mat-sys-level-1);">
    <div class="title mb-10">Actual Medication</div>

    <mat-form-field appearance="outline" floatLabel="always" style="display:block; width: 100%;">
        <mat-label>Actual medication (RxNorm search)</mat-label>

        <input matInput [formControl]="rxNormMedicationCtrl" [matAutocomplete]="icd11Auto"
            placeholder="Type to search RxNorm..." />

        <span matSuffix style="display:inline-flex; align-items:center; cursor:pointer;" (click)="clearSearch()">
            <mat-icon>autorenew</mat-icon>
        </span>

        <mat-autocomplete #icd11Auto="matAutocomplete" [displayWith]="displayRxNormOption"
            (optionSelected)="selectOption($event.option.value)">
            <!-- @for(opt of (rxNormMergedMedicationOptions$ | async) ?? []; track $index){
            <mat-option [value]="opt">
               
                <span [ngClass]="{'g-just-flex':false, 'gap-10': true,
                        'flexC': opt.kind === 'rxnorm', 'mb-10': opt.kind === 'rxnorm'
                    }" style="align-items:center;">
                    <strong class="brand">{{ opt?.label?.display }}</strong>
                    @if(opt?.label?.ingredients){
                    <em class="ms-10">{{ opt.label.ingredients }}</em>
                    }
                    @if(opt.kind === 'stock'){
                    <span [appEmphasis]="'success'" fontSize="11px">in stock</span>
                    }
                </span>
            </mat-option>
            } -->

            @for(opt of (rxNormMergedMedicationOptions$ | async) ?? []; track $index){
            <mat-option [value]="opt">
                <!-- {{opt | json}} -->
                <span [ngClass]="{'g-just-flex':false, 'gap-10': true,
                        'flexC': opt.kind === 'rxnorm', 'mb-10': opt.kind === 'rxnorm'
                    }" style="align-items:center;">
                    @if(opt.kind === 'rxnorm'){
                    <strong class="brand">{{ opt?.label?.display }}</strong>
                    }@else{
                    <span>{{ opt.kind === 'userExactWords' ? 'Use "' : '' }}{{ opt?.label?.display }}
                        {{ opt.kind === 'userExactWords' ? '" as entered' : '' }}
                    </span>
                    }
                    @if(opt?.label?.ingredients){
                    <em class="ms-10">{{ opt.label.ingredients }}</em>
                    }
                    @if(opt.kind === 'stock'){
                    <span [appEmphasis]="'success'" fontSize="11px">in stock</span>
                    }
                </span>
            </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>

    @if(loading$ | async){
    <div style="
        position: absolute;
        left: 20px;
        right: 20px;
        top: calc(20px + 100px);
        z-index: 1000;
        background: var(--mat-sys-surface, #fff);
        border: 1px solid var(--mat-sys-outline-variant, rgba(0,0,0,0.12));
        border-radius: 6px;
        padding: 12px;
        box-shadow: 0 6px 18px rgba(0,0,0,0.18);
    ">
        <div class="g-just-flex gap-10" style="align-items:center;">
            <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
            <span>Searching RxNorm…</span>
        </div>
    </div>
    }
</div>